<template>
    <div id="app">

        <!-- Wrapper -->
        <div id="wrapper">

            <!-- Intro -->
            <section class="intro">
                <header>
                    <h1>{{ title }}</h1>
                    <p>{{ desc }}</p>
                    <ul class="actions">
                        <li><a href="#first" class="arrow scrolly"><span class="label">Next</span></a></li>
                    </ul>
                </header>
            </section>

            <!-- Section -->
            <section>
                <header>
                    <h2>Get in touch</h2>
                </header>
                <footer>
                    <ul class="items">
                        <li>
                            <h3>Phone</h3>
                            <a href="tel:0096171818899">+961 71 818 899</a>
                        </li>
                        <li>
                            <h3>Address <a :href="gMaps" target="_blank" class="gmaps">(View on Google Maps)</a></h3>
                            <span v-for="addressLine in addressLines"
                                  :key="addressLine"
                            >
                                {{addressLine}}
                            </span>
                        </li>
                        <li>
                            <h3>Follow Us</h3>
                            <ul class="icons">
                                <li>
                                    <a :href="socialFacebook" class="icon fa-facebook">
                                    <span
                                            class="label">Facebook</span>
                                    </a>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <p>
                                &copy; {{getCurrentYear()}}. All rights reserved.
                            </p>
                        </li>
                    </ul>
                </footer>
            </section>

        </div>
    </div>
</template>

<script>
    export default {
        name: 'App',
        data() {
            return {
                title: 'TCF Solar & Construction',
                desc: 'TCF Solar & Construction provides comprehensive solar power systems and construction services across Lebanon. We offer residential, commercial, and industrial solar solutions, along with expert renovation, building, and upgrade services with professional design, installation, and support.',
                addressLines: [
                    'Badih Hachem street,',
                    'Second building on the right',
                    'Kfarshima, Lebanon'
                ],
                socialFacebook: "https://www.facebook.com/p/Tcf-solar-system-construction-100076077046751/",
                gMaps: "https://maps.app.goo.gl/49kBfV9GqxsvtJfq5",
            }
        },
        props: [],
        methods: {
            getCurrentYear() {
                return (new Date()).getFullYear();
            }
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue